import {css, Stack, styled, Typography} from '@mui/material';
import {StyledManualProps} from './types';

export const StyledStack = styled(Stack)<StyledManualProps>`
	gap: 12px;
	border-radius: 6px;
	padding: 14px 16px;
	position: relative;
	overflow: hidden;
	background-repeat: no-repeat;
	background-position: ${({isRefundDesktopIcon}) =>
		isRefundDesktopIcon ? '97%' : 'bottom right'};
	background-size: auto 100%;

	${({theme}) => css`
		background-color: ${theme.colors.light.primary['06Percent']};
	`}
`;

export const StyledTypography = styled(Typography)<StyledManualProps>`
	${({theme, isLoading}) => css`
		text-decoration: ${isLoading ? 'none' : 'underline'};
		cursor: ${isLoading ? 'disabled' : 'pointer'};
		color: ${isLoading ? theme.colors.light.text.disabled : theme.colors.light.primary.main};
	`}
`;

export const StyledDescriptionTypography = styled(Typography)`
	color: ${({theme}) => theme.brand.primary.blue};
`;
